import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const Title = () => {
  return (
    <Box id="home" className="hero">
      <Container>
        <Typography variant="h2" className="hero-title" data-aos="fade-up">
          Welcome to SSN M3
        </Typography>
        <Typography variant="h5" className="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
          Innovative solutions for your business
        </Typography>
      </Container>
    </Box>
  );
};

export default Title;
